// extracted by mini-css-extract-plugin
module.exports = {"badge":"ClubsSection_badge__NiVcr","item":"ClubsSection_item__2vrhP","linkItem":"ClubsSection_linkItem__34Pzk"};